/* eslint-disable prettier/prettier */
import { Button, Col, Form, Input, Modal, Row, Select, Tag, Typography } from 'antd';
import { openNotificationWithIcon } from 'app/components/PopupNotification';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import './ModalUserDeatil.scss';
import { ValidationError, ValidationSchema } from 'app/constants';
import { useAppSelector, RootState } from 'app/store';
import { updateProfileAPI } from 'app/services/api/user';
import { setIsUpdateProfile } from 'app/pages/LoginPage/auth.slice';
import CloseModalIcon from 'app/components/CloseModal';
import FixedDialCodePhoneInput from 'app/components/PhoneInput';
const { Text, Title } = Typography;

interface ModalUserDeatilProps {
  onCancel: (value: boolean) => void;
  open: boolean;
  openChangePassword: any;
}

const ModalUserDeatil = ({ onCancel, open, openChangePassword }: ModalUserDeatilProps) => {
  const userDetail = useAppSelector((state: RootState) => state.auth.userDetail);
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [value, setValue] = useState('');
  const [contactNumber, setContactNumber] = useState<any>();
  const values = Form.useWatch([], form);
  const [submittable, setSubmittable] = React.useState<boolean>(false);
  const getValuesContactNumber = useCallback(async () => {
    setContactNumber(userDetail?.phoneNumber);
  }, [userDetail?.phoneNumber, open]);

  useEffect(() => {
    getValuesContactNumber();
  }, [getValuesContactNumber]);

  const _onSave = () => {
    try {
      form
        .validateFields()
        .then(async then => {
          const formValues = await form.getFieldsValue();
          const res = await updateProfileAPI({
            ...formValues,
            userId: userDetail?.userId,
            phoneNumber: contactNumber,
          });
          dispatch(setIsUpdateProfile());
          openNotificationWithIcon('success', res?.message);
          handleCancelModal();
        })
        .catch(error => {
          if (error?.message) {
            openNotificationWithIcon('error', error?.message);
          }
        });
    } catch (error: any) {}
  };

  const listRole = useMemo(() => {
    if (userDetail) {
      const newData = userDetail?.userProjects?.map(projects => {
        const roleName = projects?.userProjectRoles.map(role => {
          return role?.roleName;
        });
        return {
          ...projects,
          roleName: roleName,
        };
      });
      return newData;
    }
  }, [userDetail]);

  const _handleChangePassword = () => {
    openChangePassword(true);
    onCancel(false);
  };

  useEffect(() => {
    if (userDetail) {
      const initialForm = {
        firstName: userDetail?.firstName,
        lastName: userDetail?.lastName,
        fullName: userDetail?.userName,
        email: userDetail?.email,
        phoneNumber: userDetail?.phoneNumber,
        // roleTitle: userDetail?.roleTitle,
      };
      form.setFieldsValue(initialForm);
    } else {
      form.resetFields();
    }
  }, [open, userDetail]);

  const handleChangePhoneNumber = phone => {
    setContactNumber(phone);
  };

  React.useEffect(() => {
    const firstNameLength = values?.firstName?.trim()?.length || 0;
    const lastNameLength = values?.lastName?.trim()?.length || 0;

    const isOverLimit = firstNameLength > 50 || lastNameLength > 50;

    if (values?.firstName || values?.lastName) {
      const hasEmptyRequired = Object.entries(form.getFieldsValue()).some(
        ([key, value]) => value === undefined || (typeof value === 'string' && value.trim() === ''),
      );
      setSubmittable(hasEmptyRequired);
    }

    setSubmittable(isOverLimit);
  }, [values]);

  const _renderFooter = () => {
    return (
      <Row justify="end" gutter={[12, 0]}>
        <Button onClick={handleCancelModal} id="profile-modal__button--cancel">
          Cancel
        </Button>
        <Button
          type="primary"
          style={{ marginRight: 10 }}
          onClick={_onSave}
          id="profile-modal__button--save"
          disabled={submittable}
        >
          Save
        </Button>
      </Row>
    );
  };

  const handleCancelModal = () => {
    onCancel(false);
  };

  return (
    <>
      <Modal
        width={800}
        footer={_renderFooter()}
        title="Profile"
        destroyOnClose={true}
        centered
        open={open}
        onCancel={handleCancelModal}
        style={{ verticalAlign: 'top', marginTop: '100px' }}
        className="user-deatil"
        closeIcon={<CloseModalIcon {...({ name: 'close-icons' } as any)} customId={'user-deatil'} />}
      >
        <Form layout="vertical" form={form} autoComplete="off">
          <Row gutter={[12, 0]}>
            <Col span={24} style={{ marginBottom: -15 }}>
              <Row gutter={[12, 0]}>
                <Col span={12}>
                  <Form.Item
                    label="First Name"
                    name="firstName"
                    htmlFor="profile-modal__input--firstName"
                    required={true}
                    rules={[
                      {
                        required: true,
                        message: 'Please enter First Name',
                      },
                      {
                        max: values?.firstName?.trim().length > 50 ? 50 : undefined,
                        message: '',
                      },
                    ]}
                  >
                    <Input
                      id="profile-modal__input--firstName"
                      className="input_username"
                      placeholder="Enter First Name"
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="Last Name"
                    name="lastName"
                    htmlFor="profile-modal__input--lastName"
                    required={true}
                    rules={[
                      {
                        required: true,
                        message: 'Please enter Last Name',
                      },
                      {
                        max: values?.firstName?.trim().length > 50 ? 50 : undefined,
                        message: '',
                      },
                    ]}
                  >
                    <Input
                      id="profile-modal__input--lastName"
                      className="input_username"
                      placeholder="Enter Last Name"
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Col>

            <Col span={24}>
              <Row gutter={[12, 0]}>
                <Col
                  span={12}
                  style={{
                    justifyContent: 'flex-end',
                    color: values?.firstName?.trim().length > 50 ? 'red' : '',
                  }}
                >
                  <Row justify="end">{values?.firstName?.trim().length ?? 0}/50</Row>
                </Col>
                <Col
                  span={12}
                  style={{
                    justifyContent: 'flex-end',
                    color: values?.lastName?.trim().length > 50 ? 'red' : '',
                  }}
                >
                  <Row justify="end">{values?.lastName?.trim().length ?? 0}/50</Row>{' '}
                </Col>
              </Row>
            </Col>

            <Col span={24}>
              <Form.Item label="User Name" name="fullName" htmlFor="profile-modal__input--fullName">
                <Input
                  disabled
                  id="profile-modal__input--fullName"
                  type="text"
                  className="input_username"
                  placeholder="Enter Contact Number"
                />
              </Form.Item>
            </Col>

            <Col span={24}>
              <Form.Item label="Email" name="email" htmlFor="profile-modal__input--email">
                <Input
                  disabled
                  typeof=""
                  id="profile-modal__input--email"
                  className="input_username"
                  placeholder="Enter email"
                />
              </Form.Item>
            </Col>

            <Col span={24}>
              <Form.Item
                label="Contact Number"
                name="phoneNumber"
                required={true}
                htmlFor="profile-modal__input--phoneNumber"
                rules={[
                  ({ getFieldValue }) => ({
                    validator() {
                      if (!ValidationSchema.phoneNumber.test(contactNumber.trim())) {
                        return Promise.reject(new Error(ValidationError.phoneNumber));
                      }
                      return Promise.resolve();
                    },
                  }),
                ]}
              >
                <div>
                  <div
                    style={{ fontSize: 0, height: 50, width: 510, position: 'absolute', top: -5, left: -5 }}
                    id="profile-modal__display--phoneNumber"
                    role="display"
                  >
                    {contactNumber}
                  </div>

                  <FixedDialCodePhoneInput
                    id="profile-modal__input--phoneNumber"
                    contactNumber={contactNumber}
                    onChange={handleChangePhoneNumber}
                    open={open}
                  />
                </div>
              </Form.Item>
            </Col>

            <Col span={24}>
              <Form.Item label="Role" name="role" htmlFor="profile-modal__input--role">
                <div className="role-content" id="profile-modal__input--role" role="display">
                  {listRole?.map(pro => {
                    return (
                      <Row style={{ color: '#002060', alignItems: 'center' }} className="mt-5">
                        <div className="pg-dot"></div>
                        <div>{pro?.projectName}: </div>
                        <div>{pro?.roleName?.join(', ')}</div>
                      </Row>
                    );
                  })}
                </div>
              </Form.Item>
            </Col>

            <Col span={24} style={{ display: 'flex', justifyContent: 'end' }}>
              <Text
                onClick={_handleChangePassword}
                style={{
                  textDecoration: 'underline',
                  fontSize: '14px',
                  fontWeight: '400',
                  color: '#002060',
                  cursor: 'pointer',
                }}
                role="display"
                id="profile-modal__text--change-password"
              >
                Change password
              </Text>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};

export default ModalUserDeatil;
